function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    focusable: "false",
    "aria-hidden": "true",
    stroke: "#4b5661",
    fill: "none",
    style: {
      display: "block",
      maxWidth: "100%",
      maxInlineSize: "100%",
      maxHeight: "100%",
      maxBlockSize: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m1.4 4.2 1.959-2.612a.47.47 0 0 1 .376-.188h6.53a.47.47 0 0 1 .376.188L12.6 4.2m-11.2 0h11.2m-11.2 0S.8 7 2.8 6.989m9.8-2.79s.6 2.8-1.4 2.79m-8.4 0c2 .01 2.2-2.79 2.2-2.79S5 7 7 7s2-2.8 2-2.8.2 2.8 2.2 2.79m-8.4 0v5.14c0 .26.21.47.47.47H5.6m5.6-5.61v5.14c0 .26-.21.47-.47.47H8.3m-2.7 0V9.57c0-.259.21-.47.47-.47h1.76c.26 0 .47.211.47.47v3.03m-2.7 0h2.7",
    style: {
      vectorEffect: "non-scaling-stroke",
      strokeWidth: "1.4px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelIcon);
export default __webpack_public_path__ + "static/media/parcelIcon.6cf95d524fe767518ea61d50e4dbc5e1.svg";
export { ForwardRef as ReactComponent };